import { ca } from '@cian/analytics';

export const trackRoomsTagClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BuildingProgress_JK',
    pageType: 'BuildingProgressJK',
    action: 'tag_click',
    label: 'show_flats',
  });
};
